import React, { useEffect, useState } from 'react';
import { useScheduledNotifications } from '../hooks/useScheduledNotifications';
import { FaCheckCircle, FaTimesCircle, FaTrash } from 'react-icons/fa';
import '../styles/modal.scss';

export const ScheduledNotificationHistoryModal = ({ isOpen, onClose, schedule }) => {
    const { fetchScheduledNotificationHistory, clearScheduledNotificationHistory } = useScheduledNotifications();
    const [history, setHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isClearing, setIsClearing] = useState(false);

    useEffect(() => {
        if (isOpen && schedule) {
            setIsLoading(true);
            fetchScheduledNotificationHistory(schedule._id)
                .then(setHistory)
                .finally(() => setIsLoading(false));
        }
    }, [isOpen, schedule]);

    const handleClear = async () => {
        if (!schedule) return;
        if (!window.confirm('هل أنت متأكد من مسح سجل هذه الجدولة بالكامل؟')) return;

        setIsClearing(true);
        const success = await clearScheduledNotificationHistory(schedule._id);
        if (success) {
            setHistory([]);
        }
        setIsClearing(false);
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('ar-LY', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content notification-modal scheduled-notification-history-modal" onClick={e => e.stopPropagation()}>
                <h2 className="TXT-heading2 color-normal">سجل الإرسال: {schedule?.name}</h2>

                {isLoading ? (
                    <div className="loading">جاري التحميل...</div>
                ) : history.length === 0 ? (
                    <p className="empty-history">لا يوجد سجل إرسال لهذه الجدولة بعد</p>
                ) : (
                    <ul className="history-list">
                        {history.map(entry => (
                            <li key={entry._id} className="history-item">
                                <div className="history-item-header">
                                    {entry.isSuccessful ? (
                                        <FaCheckCircle className="success" />
                                    ) : (
                                        <FaTimesCircle className="failed" />
                                    )}
                                    <span className="history-date">{formatDate(entry.createdAt)}</span>
                                </div>
                                <p className="history-title">{entry.title}</p>
                                <p className="history-sent-to">تم الإرسال إلى {entry.sentTo} مستلم</p>
                            </li>
                        ))}
                    </ul>
                )}

                <div className="modal-actions">
                    <button type="button" className="cancel-btn" onClick={onClose}>
                        إغلاق
                    </button>
                    {history.length > 0 && (
                        <button
                            type="button"
                            className="submit-btn danger-btn"
                            onClick={handleClear}
                            disabled={isClearing}
                        >
                            {isClearing ? (
                                <span className="loading-spinner"></span>
                            ) : (
                                <>
                                    <FaTrash />
                                    <span>مسح السجل</span>
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ScheduledNotificationHistoryModal;
